import React, { useEffect, useState, useRef } from "react";
import axios from "../../services/api";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";

const statusConfig = {
  Pending:            { color: "amber",  icon: "fa-clock",          label: "Pending" },
  Approved:           { color: "green",  icon: "fa-check-circle",   label: "Approved" },
  Rejected:           { color: "red",    icon: "fa-times-circle",   label: "Rejected" },
  "Partially Issued": { color: "purple", icon: "fa-boxes",          label: "Partial Issued" },
  Issued:             { color: "blue",   icon: "fa-clipboard-check", label: "Issued" },
};

const DashboardSummary = () => {
  const { activeBranch } = useContext(AuthContext);
  console.log("ACTIVE BRANCH:", activeBranch);
  const [summary, setSummary] = useState({});
  const [role, setRole] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const calendarRef = useRef(null);

  const user = JSON.parse(localStorage.getItem("user"));

 useEffect(() => {

  if (!activeBranch?.id) return;

  fetchSummary();

  setRole(user.role || "");

}, [activeBranch?.id]);

  const fetchSummary = async () => {
    try {
      const role = user.role;
      const user_id = localStorage.getItem("user_id");
      const res = await axios.post("/requisitions/summary", {
  role,
  user_id,
  branch_id: activeBranch.id,
});
      setSummary(res.data);
    } catch (error) {
      console.error("Error fetching requisition summary:", error);
    }
  };

  const getVisibleCards = () => {
    switch (role) {
      case "user":
      case "admin":
        return ["Pending", "Approved", "Rejected", "Partially Issued", "Issued"];
      case "store_manager":
        return ["Approved", "Rejected", "Partially Issued", "Issued"];
      default:
        return Object.keys(statusConfig);
    }
  };

  const handleMonthChange = (e) => {
    const month = parseInt(e.target.value, 10);
    setSelectedMonth(month);
    goToDate(selectedYear, month);
  };

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value, 10);
    setSelectedYear(year);
    goToDate(year, selectedMonth);
  };

  const goToDate = (year, month) => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      calendarApi.gotoDate(new Date(year, month, 1));
    }
  };

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i);

  const visibleCards = getVisibleCards();

  return (
    <div>
      {/* ── Page header ── */}
      <div className="ims-page-header mb-3">
        <div>
          <h4>Dashboard</h4>
          <p>Requisition summary overview</p>
        </div>
      </div>

      {/* ── Stat cards ── */}
      <div className="row">
        {visibleCards.map((status) => {
          const cfg = statusConfig[status] || { color: "blue", icon: "fa-clipboard-list", label: status };
          return (
            <div key={status} className="col-6 col-md-4 col-lg-3">
              <div className={`ims-stat-card ${cfg.color}`}>
                <div className={`ims-stat-icon`}>
                  <i className={`fas ${cfg.icon}`}></i>
                </div>
                <div>
                  <div className="ims-stat-value">{summary[status] ?? 0}</div>
                  <div className="ims-stat-label">{cfg.label} Requisitions</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* ── Calendar ── */}
      <div className="card mt-2" style={{ borderRadius: "12px", boxShadow: "0 1px 6px rgba(0,0,0,.07)", border: "none" }}>
        <div className="card-header d-flex justify-content-between align-items-center" style={{ background: "#f8fafc", borderRadius: "12px 12px 0 0", borderBottom: "1px solid #f1f5f9" }}>
          <span style={{ fontWeight: 700, color: "#0f172a", fontSize: "14px" }}>
            <i className="fas fa-calendar-alt mr-2 text-primary"></i>Calendar
          </span>
          <div className="d-flex gap-2">
            <select
              value={selectedMonth}
              onChange={handleMonthChange}
              className="form-control form-control-sm d-inline-block mr-2"
              style={{ width: "130px" }}
            >
              {monthNames.map((month, index) => (
                <option key={index} value={index}>{month}</option>
              ))}
            </select>
            <select
              value={selectedYear}
              onChange={handleYearChange}
              className="form-control form-control-sm d-inline-block"
              style={{ width: "90px" }}
            >
              {years.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="card-body p-3">
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            height="auto"
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardSummary;
